module.exports = __webpack_public_path__ + "img/santuario.c3ecd0c2.jpg";